import type { ReactNode } from 'react';

/**
 * 좁은 화면(390 등)에서 긴 편집 양식의 주요 동작을 스크롤 영역 하단에 붙여 둔다.
 * sm 이상에서는 일반 흐름 그대로 둔다. 버튼 문구·동작은 호출한 편집기가 소유한다.
 */
export function EditActionBar({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div
      role="group"
      aria-label={label}
      data-edit-action-bar=""
      className="bg-background sticky bottom-0 z-10 flex flex-wrap gap-2 border-t py-2 sm:static sm:border-t-0 sm:bg-transparent sm:py-0"
    >
      {children}
    </div>
  );
}
